import { createSelector } from 'reselect'
import { isSpam } from '../utils/state'
import { selectCurrentConversation } from './selectCurrentConversation'

export const selectCurrentConversationIsSpam = createSelector(
  selectCurrentConversation,
  isSpam
)
